import { useMemo } from "react";

import { ForLoopConfiguration, LoopType } from "../types";

import { usePromptTemplateInputVariables } from "@/queries/prompts/usePromptTemplateInputVariables";
import { useGetWorkflowIdByName } from "@/queries/workflows";
import useWorkflowVersion from "@/queries/workflows/useWorkflowVersion";

export const useForLoopInputVariables = (configuration: ForLoopConfiguration | undefined) => {
  const loopType = configuration?.loop_type || LoopType.PROMPT;

  const promptConfig = configuration?.prompt_config;
  const {
    inputVariables: promptInputVariables,
    isLoading: promptIsLoading,
    error: promptError,
  } = usePromptTemplateInputVariables(promptConfig);

  const workflowConfig = configuration?.workflow_config;
  const workflowName = loopType === LoopType.WORKFLOW ? workflowConfig?.name : undefined;
  const workflowIdQuery = useGetWorkflowIdByName(workflowName);

  const workflowVersion = useWorkflowVersion({
    workflowName: workflowName,
    label: workflowConfig?.workflow_label_name,
    number: workflowConfig?.workflow_version_number,
  });

  const inputVariables = useMemo(() => {
    if (loopType === LoopType.PROMPT) {
      return promptInputVariables;
    }
    return Object.keys(workflowVersion.data?.required_input_variables ?? {});
  }, [loopType, promptInputVariables, workflowVersion.data]);

  const isLoading =
    loopType === LoopType.PROMPT
      ? promptIsLoading
      : workflowIdQuery.isLoading || workflowVersion.isLoading;

  const error =
    loopType === LoopType.PROMPT ? promptError : workflowIdQuery.error || workflowVersion.error;

  return {
    inputVariables,
    isLoading,
    error,
  };
};
